import md5 from "crypto-js/md5";

// const APP_ID = "20230821001787897";
// const APP_KEY = "HL2ZPDjk5xD3n_xdUYD7";

const APP_ID = "20230821001787897"; // 需在百度控制台创建
const APP_KEY = "HL2ZPDjk5xD3n_xdUYD7"; // 需开通翻译服务
// const API_ENDPOINT = "https://api.fanyi.baidu.com/api/trans/vip/translate";
export interface TranslateResult {
  src: string;
  dst: string;
}

export const translate = async (
  text: string,
  toLang: string,
  fromLang = "auto"
): Promise<TranslateResult[]> => {
  const salt = Date.now().toString();
  const sign = md5(APP_ID + text + salt + APP_KEY).toString();

  const response = await fetch(
    `/api/translate?` +
      new URLSearchParams({
        q: text,
        from: fromLang,
        to: toLang,
        appid: APP_ID,
        salt,
        sign,
      })
  );

  const data = await response.json();
  return data.trans_result;
};

// export interface TranslateResult {
//   src: string;
//   dst: string;
// }

// export const translate = async (
//   text: string,
//   toLang: string,
//   fromLang = "auto"
// ): Promise<TranslateResult[]> => {
//   try {
//     const salt = Date.now().toString();
//     console.log(`salt:${salt}`);
//     // 确保签名生成正确（appid+q+salt+appkey）
//     const sign = md5(APP_ID + text + salt + APP_KEY).toString();
//     console.log(`sign:${sign}`);

//     if (!text || text.length === 0) {
//       throw new Error("翻译文本不能为空");
//     }

//     const response = await fetch("/api/translate", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ text, fromLang, toLang }),
//     });

//     // 增加HTTP错误状态处理
//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(`API Error ${response.status}: ${errorData.error_msg}`);
//     }

//     const data = await response.json();

//     // 处理百度API业务错误
//     if (data.error_code) {
//       throw new Error(
//         `Translation Error ${data.error_code}: ${data.error_msg}`
//       );
//     }

//     return data.trans_result;
//   } catch (error) {
//     console.error("Translation failed:", error);
//     throw error; // 继续抛出以供上层处理
//   }
// };
